import qs from "qs";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import Back from "~/components/Icons/arrow-prev2";
import Preloader from "~/components/Preloader";
import useGetStaffDataEmployeDealerLevel from "~/pages/Employee/hook/useGetStaffDataEmployeDealerLevel";
import StaffFilter, { IEmployeeFilter } from "~/pages/Staff/assets/StaffFilter";
import useRequestHandler from "~/shared/hooks/useRequestHandler";
import Button from "~/shared/ui/Fields/Button";
import { useEmployee } from "~/entity/Employee";
import { toEmployeeEducationDealerReportFilter } from "~/entity/Employee/lib/converter";
import { useGetLocationData } from "~/hooks/locationData";
import { getShortDate } from "~/libs/getFormatDate";
import { getEmployeeColumns } from "~/pages/Employee/model/tableAdapter";
import { EMPLOYEE_TRAINING } from "~/pages/Employee/options";
import { EmployeeSummary } from "~/pages/Employee/ui/EmployeeSummary";
import { defaultStaffFilterValues } from "~/pages/Staff";
import { getFilterStaffFromLocation } from "~/pages/Staff/lib/getFilterStaffFromLocation";
import { resolveFilterToRequest } from "~/pages/Staff/lib/resolveFilterToRequest";
import { useNotify } from "~/shared/hooks/useNotify";
import { dateFormatForREST } from "~/shared/lib/dateFormatForREST";
import { TableV2 } from "~/shared/ui/TableV2";

import s from "./s.less";

const language = localStorage.getItem("language");
const isRu = language === "ru";

const Employee = () => {
  const { t } = useTranslation();

  console.log(1111111111111111111111111111);

  function normalizePeriod(period: string): string {
    let date: Date;

    if (period.includes("GMT") && !period.includes("T")) {
      date = new Date(period);
    } else if (period.includes("T") && period.endsWith("Z")) {
      date = new Date(period);
    } else {
      date = new Date(period);
    }
    if (isNaN(date.getTime())) {
      throw new Error("Invalid date format");
    }
    return date.toISOString();
  }
  const { filterBy, period, position, employeeIds, filterItems } =
    useGetLocationData() as any;
  const params = new URLSearchParams(location.search);
  const positionIds = JSON.parse(params.get("positionId"));

  let normalizedPeriod: string;

  try {
    normalizedPeriod = period
      ? normalizePeriod(period)
      : new Date().toISOString();
  } catch (e) {
    normalizedPeriod = new Date().toISOString();
  }

  const [filterData, setFilterData] = useState<Partial<IEmployeeFilter>>({
    ...(!!filterBy && !!filterItems && normalizedPeriod!
      ? getFilterStaffFromLocation(filterBy, filterItems, normalizedPeriod)
      : {
          ...defaultStaffFilterValues(),
          period: new Date(),
        }),
  });

  const employee = employeeIds && employeeIds.split(",");

  console.log(employee, "employee");

  const { notifyReport } = useNotify();
  const getShortDateParams = resolveFilterToRequest(filterData, isRu);

  const urlParams = qs.stringify(
    {
      positionIds,
      employeeIds: employee ? employee : [],
      dealerGroup: {
        ids: getShortDateParams.DealerIds ?? [],
        cities: getShortDateParams.city ?? [],
        FOs: getShortDateParams.FO ?? [],
        countries: getShortDateParams.country ?? [],
        subjects: getShortDateParams.subject ?? [],
      },
      actualOn: getShortDate(period ?? filterData.period),
    },
    { allowEmptyArrays: true, arrayFormat: "brackets" }
  );

  console.log(urlParams, "urlParams");

  const { data: dataLevel, isLoading: isLoadingLevel } =
    useGetStaffDataEmployeDealerLevel(urlParams);

  console.log(dataLevel, "dataLeveldataLeveldataLevel");

  const [_, setFilter] = useState(false);
  const goBack = () => window.close();

  const { getDealerLevelReport } = useEmployee();
  const { requestWithNotifHandler } = useRequestHandler();
  const [loadingReport, setLoadingReport] = useState(false);
  const onGetReport = async () => {
    const filter = resolveFilterToRequest(filterData, isRu);
    console.log("filter", filter);
    const dataToServer = {
      employeeIds: dataLevel?.employees
        ? dataLevel.employees.map((el) => el.employeeId)
        : [],
      positionIds,
      actualOn: dateFormatForREST(filterData.period.toISOString(), "Andrey"),
      dealerGroup: toEmployeeEducationDealerReportFilter(filter),
    };

    setLoadingReport(true);
    requestWithNotifHandler({
      request: async () => getDealerLevelReport(dataToServer),
      callback: async ({ fileHash }) => {
        try {
          await notifyReport(fileHash);
        } catch (e) {
          console.log(e);
        }
      },
      errorPrefixMessage: "Ошибка формирования файла",
    }).finally(() => setLoadingReport(false));
  };
  const toggleFilter = () => setFilter((p) => !p);

  const redirectToUserProfile = (id: string) => () =>
    window.open(`/base/viewing/${id}`, "_blank");
  const redirectToUserProfilePersonal = (id: string, name: string) => () => {
    const link = `/staff/employee?position=${encodeURIComponent(
      position || ""
    )}&positionId=${positionIds || ""}&filterBy=${filterBy || ""}&filterItems=${
      filterItems || ""
    }&period=${period || ""}${
      employeeIds && employeeIds !== "undefined"
        ? `&employeeIds=${employeeIds}`
        : ""
    }`;

    const url = `/staff/employee/personal?UserId=${id}&dateBegin=${normalizedPeriod}&currentId=${
      positionIds || ""
    }&positionNames=${encodeURIComponent(
      position || ""
    )}&name=${encodeURIComponent(name || "")}&link=${encodeURIComponent(link)}`;

    window.open(url, "_blank");
  };
  const columns = getEmployeeColumns(
    t,
    EMPLOYEE_TRAINING,
    redirectToUserProfile
  );

  const handleViewEmployeeTraining = (record: {
    employeeId: string;
    surname: string;
    name: string;
    middleName: string;
  }) => {
    redirectToUserProfilePersonal(
      record.employeeId,
      `${record.surname} ${record.name} ${record.middleName}`
    )();
  };

  return (
    <div className={s.staff_wrapper}>
      <div className={s.title}>
        <Button
          txtBtn={""}
          onlyIcon
          onClick={goBack}
          customClassName={s.iconBack}
        >
          <Back />
        </Button>
        {t("employeeTraining.title")} <span>{position || "Не определено"}</span>
      </div>
      <div className={s.buttonWrapper}>
        <div className={s.filterWrapper}>
          <StaffFilter
            toggleFilter={toggleFilter}
            filterData={filterData}
            setFilterData={setFilterData}
            isEmployee
          />
        </div>
        <Button
          txtBtn={"Скачать отчет"}
          small
          green
          customClassName={s.buttonHistory}
          onClick={onGetReport}
          disabled={loadingReport}
        />

        {/*)}*/}
      </div>
      {isLoadingLevel ? (
        <Preloader />
      ) : (
        dataLevel?.employees.length > 0 && (
          <TableV2
            columns={columns}
            dataSource={dataLevel?.employees}
            rowKey="employeeId"
            onViewDetails={handleViewEmployeeTraining}
            actionsFixed
            loading={isLoadingLevel}
            wrapperClassName={s.staff_table}
            pagination={false}
            rowDecorator={(record) =>
              record.isMoratorium ? { className: s.row_moratorium } : {}
            }
            {...(!!dataLevel?.totals
              ? {
                  summary: () => <EmployeeSummary totals={dataLevel?.totals} />,
                }
              : null)}
          />
        )
      )}
    </div>
  );
};

export default Employee;
